import { LayoutComponent } from './core/layout/layout.component';
import { LoginComponent } from './login/login.component';
import { RecoverComponent } from './routes/pages/recover/recover.component';
import { LockComponent } from './routes/pages/lock/lock.component';
import { MaintenanceComponent } from './routes/pages/maintenance/maintenance.component';
import { Error404Component } from './routes/pages/error404/error404.component';
import { Error500Component } from './routes/pages/error500/error500.component';
import { AuthGuard } from './core/guards/auth.guard';

export const routes = [

    {
        path: '',
        component: LayoutComponent,
        canActivateChild: [AuthGuard],
        children: [
            { path: '', redirectTo: 'eleve', pathMatch: 'full' },
            // Pour le moment, l'univers Famille n'est pas proposé aux utilisateurs ayant le rôle professeur

            { path: 'famille', loadChildren: './famille/famille.module#FamilleModule' },
            { path: 'eleve', loadChildren: './eleve/eleve.module#EleveModule' },
            { path: 'professeur', loadChildren: './professeur/professeur.module#ProfesseurModule' },
            { path: 'cours', loadChildren: './cours/cours.module#CoursModule' },
            { path: 'planning', loadChildren: './planning/planning.module#PlanningModule' },
            { path: 'courriel', loadChildren: './courriel/courriel.module#CourrielModule' },
            { path: 'sms', loadChildren: './sms/sms.module#SmsModule' },
            { path: 'bulletin', loadChildren: './bulletin/bulletin.module#BulletinModule' },
            { path: 'examens', loadChildren: './examens/examens.module#ExamensModule' },
            { path: 'administration', loadChildren: './administration/administration.module#AdministrationModule' },
            { path: 'parametrage', loadChildren: './parametrage/parametrage.module#ParametrageModule' },
            { path: 'moncompte', loadChildren: './moncompte/moncompte.module#MoncompteModule' },
        ]
    },

    // Not lazy-loaded routes
    { path: 'login', component: LoginComponent },
    { path: 'recover', component: RecoverComponent },
    { path: 'lock', component: LockComponent },
    { path: 'maintenance', component: MaintenanceComponent },
    { path: '404', component: Error404Component },
    { path: '500', component: Error500Component },

    // Not found
    { path: '**', redirectTo: '', pathMatch: 'full' }

];



// WEBPACK FOOTER //
// /builds/eveasoft/lea/lea-front/src/app/app.routes.ts